// ============================================
// orderFormat.js — formateo y etiquetas de pedidos (compartido)
// Physiology New Look · Medusa v2
//
// Centraliza el formato de moneda/fecha y los mapas de estado (fulfillment y
// pago) que antes vivían duplicados en OrderHistory y DistributorProgram.
// ============================================

// Medusa v2 expone montos en unidades mayores (pesos), sin dividir.
export function formatPrice(amount, currencyCode = 'MXN') {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: currencyCode || 'MXN',
  }).format(amount || 0);
}

export function formatDate(dateString) {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('es-MX', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

const FULFILLMENT_LABELS = {
  not_fulfilled: 'Sin enviar',
  partially_fulfilled: 'Parcialmente enviado',
  fulfilled: 'Enviado',
  partially_shipped: 'Parcialmente enviado',
  shipped: 'En camino',
  partially_delivered: 'Parcialmente entregado',
  delivered: 'Entregado',
  partially_returned: 'Parcialmente devuelto',
  returned: 'Devuelto',
  canceled: 'Cancelado',
};

const PAYMENT_LABELS = {
  not_paid: 'No pagado',
  awaiting: 'En espera',
  authorized: 'Autorizado',
  captured: 'Pagado',
  partially_refunded: 'Parcialmente reembolsado',
  refunded: 'Reembolsado',
  canceled: 'Cancelado',
  requires_action: 'Requiere acción',
};

export function getFulfillmentStatusLabel(status) {
  return FULFILLMENT_LABELS[status] || status || 'Pendiente';
}

export function getPaymentStatusLabel(status) {
  return PAYMENT_LABELS[status] || status || 'Pendiente';
}

// Stepper de 4 pasos: Recibido · Procesando · Enviado · Entregado.
export const ORDER_STEPS = ['Recibido', 'Procesando', 'Enviado', 'Entregado'];

export function stepIndexFromOrder(order) {
  if (!order) return -1;
  const fs = order.fulfillment_status;
  if (fs === 'delivered' || fs === 'partially_delivered') return 3;
  if (fs === 'shipped' || fs === 'partially_shipped') return 2;
  if (fs === 'fulfilled' || fs === 'partially_fulfilled') return 1;
  return 0;
}
